import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';
import { serverValidators } from '../utils/validators';

export enum ColumnKeys {
  SERVER = 'server',
  USE_PROXY = 'useProxy',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: DefaultColumnKeys.REORDER,
      header: '',
      columnType: IColumnType.DISPLAY,
    },
    {
      key: DefaultColumnKeys.PRIORITY,
      header: translateFn('Priority'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: ColumnKeys.SERVER,
      header: translateFn('Server'),
      columnType: IColumnType.TEXT,
      editable: true,
      validators: serverValidators(),
    },
    {
      key: ColumnKeys.USE_PROXY,
      header: translateFn('Proxy'),
      columnType: IColumnType.DISPLAY,
      editable: true,
      renderer: typeCellCustomRenderer,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

export function typeCellCustomRenderer(
  content: boolean,
  column: IDataTableColumn,
  rowIndex: number,
  editMode: boolean
): TemplateResult {
  if (editMode) {
    return html`
      <gz-form-field id="${column.key}-row${rowIndex}-form-field" class="edit-form-field">
        <gz-checkbox gz-form-input style="bottom: 5px; height: 18px" ?checked="${content}"></gz-checkbox>
      </gz-form-field>
    `;
  } else {
    return html` <gz-checkbox style="display: block; height: 18px" ?checked="${content}" disabled></gz-checkbox> `;
  }
}
